const VK_MENTION_RE = /\[.*?\|(.*?)\]/g;
const WS_RE = /\s/g;

/** Количество знаков без пробелов (с учётом сворачивания VK-меншенов).
 *  Повторяет серверный механизм подсчёта (text_utils.count_chars_no_spaces). */
export function countCharsNoSpaces(text: string): number {
  const cleaned = (text ?? "").replace(VK_MENTION_RE, "$1").replace(WS_RE, "");
  return cleaned.length;
}

export function countLinks(raw: string): number {
  if (!raw) return 0;
  return raw.split(/\r?\n/).filter((l) => l.trim().length > 0).length;
}

const YANDEX_DISK_RE = /^https:\/\/disk\.yandex\.[a-z]+\/[a-z]\/\S+/i;

export function isYandexDiskLink(url: string): boolean {
  return YANDEX_DISK_RE.test(url.trim());
}

/** Копирует текст в буфер обмена. Возвращает true при успехе. */
export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // упадём в фолбэк ниже
  }
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
